"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toolbar = void 0;
const react_1 = __importDefault(require("react"));
const react_components_1 = require("@remirror/react-components");
const clsx_1 = __importDefault(require("clsx"));
const ItalicButton_1 = __importDefault(require("./Tools/Italic/ItalicButton"));
const UnderlineButton_1 = __importDefault(require("./Tools/Underline/UnderlineButton"));
const BoldButton_1 = __importDefault(require("./Tools/Bold/BoldButton"));
const TextAlignButtons_1 = __importDefault(require("./Tools/TextAlign/TextAlignButtons"));
const UndoButton_1 = __importDefault(require("./Tools/Undo/UndoButton"));
const RedoButton_1 = __importDefault(require("./Tools/Redo/RedoButton"));
const TextTypeDropdown_1 = __importDefault(require("./Tools/TextType/TextTypeDropdown"));
const LinkButton_1 = __importDefault(require("./Tools/Link/LinkButton"));
const ImageButton_1 = __importDefault(require("./Tools/Image/ImageButton"));
const RemoveLinkButton_1 = __importDefault(require("./Tools/Link/RemoveLinkButton"));
const ClearFormattingButton_1 = __importDefault(require("./Tools/ClearFormatting/ClearFormattingButton"));
const ListButtons_1 = __importDefault(require("./Tools/Lists/ListButtons"));
const HorizontalLineButton_1 = __importDefault(require("./Tools/HorizontalLine/HorizontalLineButton"));
const TableButton_1 = __importDefault(require("./Tools/Table/TableButton"));
const ContentToolsDropdown_1 = __importDefault(require("./Tools/ContentTools/ContentToolsDropdown"));
const hooks_1 = require("../hooks");
const react_dom_1 = require("react-dom");
const Toolbar = ({ isVisible, enableTableTool, container }) => {
    const extensionNames = (0, hooks_1.useExtensionNames)();
    const toolbar = (react_1.default.createElement(react_components_1.Toolbar, { className: (0, clsx_1.default)('editor-toolbar header-toolbar', isVisible && 'show-toolbar', container && 'fte-portal-toolbar'), role: "toolbar", tabIndex: 0 },
        react_1.default.createElement("div", { className: "editor-toolbar__tools" },
            extensionNames.history && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(UndoButton_1.default, null),
                react_1.default.createElement(RedoButton_1.default, null),
                react_1.default.createElement(react_components_1.VerticalDivider, null))),
            extensionNames.heading && extensionNames.paragraph && extensionNames.preformatted && react_1.default.createElement(TextTypeDropdown_1.default, null),
            extensionNames.bold && react_1.default.createElement(BoldButton_1.default, null),
            extensionNames.italic && react_1.default.createElement(ItalicButton_1.default, null),
            extensionNames.underline && react_1.default.createElement(UnderlineButton_1.default, null),
            extensionNames.nodeFormatting && react_1.default.createElement(TextAlignButtons_1.default, null),
            extensionNames.listItem && react_1.default.createElement(ListButtons_1.default, null),
            extensionNames.horizontalRule && react_1.default.createElement(HorizontalLineButton_1.default, null),
            extensionNames.link && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(LinkButton_1.default, null),
                react_1.default.createElement(RemoveLinkButton_1.default, null))),
            extensionNames.image && react_1.default.createElement(ImageButton_1.default, null),
            extensionNames.clearFormatting && react_1.default.createElement(ClearFormattingButton_1.default, null),
            enableTableTool && extensionNames.table && react_1.default.createElement(TableButton_1.default, null),
            react_1.default.createElement(ContentToolsDropdown_1.default, null))));
    return container ? (0, react_dom_1.createPortal)(toolbar, container) : toolbar;
};
exports.Toolbar = Toolbar;
